import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Api } from '../Api';

import helpers from '../util/helpers';

import "../css/Login.css";

class LoginPage extends Component {
  constructor() {
    super()
    this.state = { access_code: "", error: false };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onClick() {
    Api.authenticate(this.state.access_code).then((response) => {
      if(response.success === false) {
            helpers.eventLog("event - login failed");
            this.setState({ error: true })
      }
      else {
        this.logBrowserMetrics()
        this.props.appState.logIn();
        this.props.history.push('/avatar');
        this.props.appState.loadMeasurements()
        this.props.appState.loadHeadlines()
      }
    });
  }

  logBrowserMetrics() {
    let options = []
    let header = [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera]
    let dataos = [
      { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
      { name: 'Windows', value: 'Win', version: 'NT' },
      { name: 'iPhone', value: 'iPhone', version: 'OS' },
      { name: 'iPad', value: 'iPad', version: 'OS' },
      { name: 'Kindle', value: 'Silk', version: 'Silk' },
      { name: 'Android', value: 'Android', version: 'Android' },
      { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
      { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
      { name: 'Macintosh', value: 'Mac', version: 'OS X' },
      { name: 'Linux', value: 'Linux', version: 'rv' },
      { name: 'Palm', value: 'Palm', version: 'PalmOS' }
    ]
    let databrowser = [
      { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
      { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
      { name: 'Safari', value: 'Safari', version: 'Version' },
      { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
      { name: 'Opera', value: 'Opera', version: 'Opera' },
      { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
      { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
    ]

    let matchItem = function (string, data) {
      var i = 0,
          j = 0,
          html = '',
          regex,
          regexv,
          match,
          matches,
          version;

      for (i = 0; i < data.length; i += 1) {
        regex = new RegExp(data[i].value, 'i');
        match = regex.test(string);
        if (match) {
          regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
          matches = string.match(regexv);
          version = '';
          if (matches) { if (matches[1]) { matches = matches[1]; } }
          if (matches) {
            matches = matches.split(/[._]+/);
            for (j = 0; j < matches.length; j += 1) {
              if (j === 0) {
                version += matches[j] + '.';
              } else {
                version += matches[j];
              }
            }
          } else {
            version = '0';
          }
          return {
            name: data[i].name,
            version: parseFloat(version)
          };
        }
      }
      return { name: 'unknown', version: 0 };
    }

    let agent = header.join(' ')
    let os = matchItem(agent, dataos)
    let browser = matchItem(agent, databrowser)

    let platformString = `${os.name}${os.version}`
    let browserString = `${browser.name}${browser.version}`

    var width = window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;

    var height = window.innerHeight
    || document.documentElement.clientHeight
    || document.body.clientHeight;

    let browserData = {
      device: platformString,
      browser: browserString,
      width: width,
      height: height,
    }
    helpers.eventLog(`deviceAnalytics - device:${platformString},browser:${browserString},width:${width},height:${height}`) /// to do change to normal string
  }

  onChange(e) {
    this.setState({ access_code: e.target.value });
  }

  render() {
    // if we got to this page (by clicking the back button, for example) log out
    // so that the user doesn't mistakenly think they are logged out and leave
    // the computer with their data still accessible
    this.props.appState.logOut();

    const error = this.state.error ? (<FormattedMessage id='app.login.failed' defaultMessage='Incorrect access code.  Please try again.' />) : null;

    return (
      <div className="page login">
        <img src={`${process.env.PUBLIC_URL}/images/women-with-babies.jpg`} width='100%' alt='' />

        <h1>
          <FormattedMessage id='app.login.header' defaultMessage='Login' />
        </h1>

        <p>
          <FormattedMessage id='app.login.content' defaultMessage='Enter your access code to get your results.' />
        </p>

        {error}

        <div>
          <input type='text' placeholder='' size='10' value={this.state.access_code} onChange={this.onChange.bind(this)} />
        </div>

        <a className='button' onClick={this.onClick.bind(this)}>
          <FormattedMessage id='app.login.submit' defaultMessage="Submit" />
        </a>
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/pages/LoginPage.js